import HttpService from "./htttp.service";

class AddonsService {
  // AddonsEndpoint = process.env.API_URL;

  getAddons = async () => {
    const getAddons = "dash/addons";
    return await HttpService.get(getAddons);
  };

  getSingleAddon = async (id) => {
    const getSingleAddon = `dash/addons/${id}`;
    return await HttpService.get(getSingleAddon);
  };

  createAddons = async (payload) => {
    const createAddons = "dash/addons/new";
    return await HttpService.post(createAddons, payload);
  };

  editAddons = async (id, payload) => {
    const editAddons = `dash/addons/${id}`;
    return await HttpService.put(editAddons, payload);
  };

  deleteAddons = async (id, payload) => {
    const deleteAddons = `dash/addons/${id}`;
    return await HttpService.delete(deleteAddons, payload);
  };
}

export default new AddonsService();
